import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { WprControlVisibility } from '../props/IWprControlState';
import { WprControlInfo } from '../../view/control/WprControlInfo';
import { WprFramework } from '../../WprFramework';
import { WprBaseInputControlComponent } from './WprBaseInputControlComponent';

/**
 * ラジオボタンプロパティ情報
 */
interface IWprRadioProps extends IWprControlProps {
	value: string			// 値
	beforeLabel?: string,	// 前ラベル
	afterLabel?: string		// 後ラベル
}

/**
 * ラジオボタンコントロール
 */
export class WprRadio extends WprBaseInputControlComponent<IWprRadioProps, HTMLInputElement> {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprRadioProps) {
		super(props);
		this.setChangeValueEvent(this.onChangeValue.bind(this));
	}
	// --------------------------------------------------------------------------

	// イベント  ----------------------------------------------------------------
	/**
	 * 値変更処理
	 * @param event 変更イベント 
	 */
	public onChangeValue(event: React.ChangeEvent<HTMLInputElement>): void {
		if (event.target.checked === false)
			return;
		const value = event.target.value;
		// const name = event.target.name;
		if (this.controlInfo != null) {
			WprControlInfo.isChangeValue = true;
			try {
				WprFramework.getInstance().view.setScopeUpdateProperty();
				this.controlInfo.dirty = true;
				if (this.props.row) {
					if (this.controlInfo.changeListValue(value, this.props.row.rowData) === false)
						return;
				}
				else {
					if (this.controlInfo.changeValue(value) === false)
						return;
				}
				this.controlInfo.viewCore.viewInfo.checkScopeModelValue();
				this.controlInfo.value = value;
			}
			finally {
				WprControlInfo.isChangeValue = false;
			}
		}
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール名称取得
	 * @returns コントロール名称
	 */
	public getName(): string {
		if (this.props.row)
			return this.props.name + this.props.row.index;
		else
			return this.props.name;
	}

	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		return this.props.value;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps('wpr-radio');
		const {name, view, className, beforeLabel, afterLabel, children, ...other} = this.props;
		const state = this.getState(['style', 'disabled', 'readOnly']);
		const checked = (this.props.value === this.state.value);
		const events = this.getEvents();
		let radio = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			radio = <input type='radio' checked={checked} {...props} {...state} {...other} {...events}/>;
		}
		else {
			state['style'] = {...this.state.style, visibility: 'hidden'};
			radio = <input type='radio' checked={checked} {...props} {...state} {...other}/>;
		}
		if ((this.props.beforeLabel || this.props.afterLabel) && this.props.id) {
			if (this.state.visibility === WprControlVisibility.VISIBLE)
				radio = <label className='wpr-radio-label' htmlFor={this.props.id}>{this.props.beforeLabel}{radio}{this.props.afterLabel}</label>;
			else
				radio = <label className='wpr-radio-label' htmlFor={this.props.id} style={{visibility: 'hidden'}}>{this.props.beforeLabel}{radio}{this.props.afterLabel}</label>;
		}
		return (
			<>
				{radio}
			</>
		);
	}

	/**
	 * プロパティチェック処理
	 */
	public onCheckProps(): void {
		if ((this.props.beforeLabel || this.props.afterLabel) && !this.props.id) {
			if (this.props.beforeLabel)
				this.addErrorLog(`beforeLabel(${this.props.beforeLabel})を指定した場合は、idを指定してください。[${this.props.name}]`);
			else
				this.addErrorLog(`afterLabel(${this.props.afterLabel})を指定した場合は、idを指定してください。[${this.props.name}]`);
		}
	}
	// --------------------------------------------------------------------------
}